export default __webpack_public_path__ + "static/media/ipX3.f84f59aa.svg";